/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConstructionHyperType } from '../models/ConstructionHyperType';
import type { PaginatedConstructionHyperTypeList } from '../models/PaginatedConstructionHyperTypeList';
import type { PatchedConstructionHyperType } from '../models/PatchedConstructionHyperType';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsConstructionHyperTypesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedConstructionHyperTypeList
     * @throws ApiError
     */
    public clientsConstructionHyperTypesList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedConstructionHyperTypeList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-construction-hyper-types/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns ConstructionHyperType
     * @throws ApiError
     */
    public clientsConstructionHyperTypesCreate({
        requestBody,
    }: {
        requestBody: ConstructionHyperType,
    }): CancelablePromise<ConstructionHyperType> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients-construction-hyper-types/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ConstructionHyperType
     * @throws ApiError
     */
    public clientsConstructionHyperTypesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this construction hyper type.
         */
        id: number,
    }): CancelablePromise<ConstructionHyperType> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-construction-hyper-types/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ConstructionHyperType
     * @throws ApiError
     */
    public clientsConstructionHyperTypesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this construction hyper type.
         */
        id: number,
        requestBody: ConstructionHyperType,
    }): CancelablePromise<ConstructionHyperType> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients-construction-hyper-types/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ConstructionHyperType
     * @throws ApiError
     */
    public clientsConstructionHyperTypesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this construction hyper type.
         */
        id: number,
        requestBody?: PatchedConstructionHyperType,
    }): CancelablePromise<ConstructionHyperType> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clients-construction-hyper-types/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public clientsConstructionHyperTypesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this construction hyper type.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients-construction-hyper-types/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
